import React, { useState } from "react";

import styles from "./NavigationRail.module.scss";
import classNames from "classnames";
import { Icon, NavigationRailTabOption } from "@livingmap/hippo";
import { OptionProps } from "@livingmap/hippo/dist/components/NavigationRailTabOption/NavigationRailTabOption";

export interface Props {
  dataQA: string;
  options: OptionProps[];
  initialCollapsed: boolean;
  buttonTooltip: string;
  className?: string;
}

const NavigationRail: React.FC<Props> = ({
  dataQA,
  options,
  initialCollapsed,
  buttonTooltip,
  className,
}) => {
  const [isCollapsed, setIsCollapsed] = useState(initialCollapsed);

  const handleTransitionClick = () => {
    setIsCollapsed(!isCollapsed);
  };
  const transitionIcon = isCollapsed ? "chevron_right" : "chevron_left";
  return (
    <div
      data-qa={dataQA}
      className={classNames(className ? className : styles.container, {
        [styles.collapsed]: isCollapsed,
      })}
    >
      <div>
        <div className={classNames(styles.headerContainer)}>
          <div className={styles.logoWrapper}>
            <Icon name={"lm_logomark"} size={24} dataQA={"transition_icon"} />
          </div>
          {!isCollapsed && <div className={styles.logoText}>Living Map</div>}
        </div>
        <NavigationRailTabOption
          options={options}
          isCollapsed={isCollapsed}
          dataQA={dataQA}
        />
      </div>
      <div
        className={classNames(styles.iconContainer, {
          [styles.collapsed]: isCollapsed,
        })}
      >
        <div
          className={classNames(styles.transitionBackground)}
          onClick={handleTransitionClick}
          title={buttonTooltip}
        >
          <Icon name={transitionIcon} size={24} dataQA={"transition_icon"} />
        </div>
      </div>
    </div>
  );
};

export default NavigationRail;
